/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { autoketingStore } from "../../contexts/appProvider";

export default function PrivateRoute({ component: Component, ...rest }) {
  const { state } = useContext(autoketingStore);
  const login = state ? state.isLogin : false;
  return (
    <Route
      {...rest}
      render={(props) => {
        if (login) {
          return <Component {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: "/login",
              state: {
                from: props.location,
              },
            }}
          />
        );
      }}
    />
  );
}
// log
